<template>
    <div class="user-review-modal">
        <b-modal ref="modal" title="Add Annual Review" size="lg" header-bg-variant="primary" header-text-variant="light"
                 no-close-on-esc no-close-on-backdrop ok-title="Add Review" @ok="addReview" :ok-disabled="loading"
                 :cancel-disabled="loading">
            <div class="review" v-if="review">
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group label="Date From">
                            <b-form-datepicker v-model="dateFrom" required />
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group label="To">
                            <b-form-datepicker v-model="review.date" required />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-form-group label="View Portfolio">
                    <b-button variant="info" :disabled="!review.date || !dateFrom" @click="downloadPortfolio"><DownloadIcon /> Download Portfolio</b-button>
                </b-form-group>
                <b-form-checkbox v-model="review.metRequirements" switch>
                    This person has met their requirements
                </b-form-checkbox>
                <b-form-group label="Comments" class="mt-2">
                    <b-textarea rows="6" v-model="review.comments"></b-textarea>
                </b-form-group>

            </div>
        </b-modal>
    </div>
</template>

<script>
    import DownloadIcon from 'vue-material-design-icons/DownloadOutline';

    const BLANK_REVIEW = {
        date: '',
        user: '',
        comments: '',
        metRequirements: false
    }

    export default {
        name: "UserReviewModal",
        components: {DownloadIcon},
        data() {
            return {
                dateFrom: '',
                review: null,
                loading: false,
            }
        },
        methods: {
            show(reviewee) {
                this.dateFrom = '';
                this.review = {...BLANK_REVIEW}
                this.review.user = reviewee;
                this.$refs.modal.show();

            },
            addReview($e) {
                $e.preventDefault();
                this.loading = true;
                this.$api.v2.post('organisations/user-review', this.review).then((resp) => {
                    this.$success('Annual Review Added', 'The annual review has been successfully added');
                    this.close();
                }).catch((resp) => {
                    this.$httpError('Failed to add review', resp);
                }).finally(() => {
                    this.loading = false;
                });
            },
            close() {
                this.$refs.modal.hide();
            },
            downloadPortfolio() {
                this.$api.v2.post('organisations/user-review/portfolio', {
                    user: this.review.user,
                    dateFrom: this.dateFrom,
                    dateTo: this.review.date
                }, {
                    responseType: 'blob'
                }).then((response) => {
                    let result = document.createElement('a');
                    let contentDisposition = response.headers.get('Content-Disposition') || '';
                    let filename;
                    if (contentDisposition) {
                        filename = contentDisposition.split('filename=')[1];
                        filename = filename.replace(/"/g, "")
                    } else {
                        filename = "portfolio.pdf";
                    }

                    return response.blob()
                        .then(function(data) {
                            if (window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveOrOpenBlob(data, filename);
                                return null;
                            } else {
                                result.href = window.URL.createObjectURL(data);
                                result.target = '_self';
                                result.download = filename;
                                return result;
                            }
                        });
                }).then(link => {
                    return () => link.click();
                }).then((download) => {
                    download();
                }).catch((resp) => {
                    this.$httpError('Failed to download', resp);
                });
            }
        }
    }
</script>

<style scoped>

</style>